// extracted by mini-css-extract-plugin
export default {"status":"status--nYff5","status__text":"status__text--a6NQn"};